import {Component, EventEmitter, OnInit, Output, TemplateRef} from '@angular/core';
import {BaseComponent, ConfirmationDialogService, LeModalService} from "common-shared";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {marker} from "@jsverse/transloco-keys-manager/marker";
import {ItemGroupsQuery} from "web-shared";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ItemGroupModel} from "web-shared";

@Component({
  selector: 'ime-manufacturing-item-group-edit-menu-buttons',
  templateUrl: './manufacturing-item-group-edit-menu-buttons.component.html',
  styles: [
  ]
})
export class ManufacturingItemGroupEditMenuButtonsComponent extends BaseComponent implements OnInit {
  manufacturedItemGroup: ItemGroupModel;
  askCopyCodeNameModal: NgbModalRef;
  @Output() showGraphClick = new EventEmitter<void>();
  @Output() copyItemGroupClick = new EventEmitter<{ code: string, name: string }>();

  constructor(private route: ActivatedRoute, private itemGroupsQuery: ItemGroupsQuery, private confirmationDialogService: ConfirmationDialogService, private modalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(params => {
      this.manufacturedItemGroup = this.route.snapshot.data.entity as ItemGroupModel ?? new ItemGroupModel();
    });
  }

  showCopyModal(template: TemplateRef<any>) {
    this.askCopyCodeNameModal = this.modalService.bsModalService.open(template);
  }

  copy(newCode: string, newName: string) {
    const existingItemGroup = this.itemGroupsQuery.getAll().find(value => value.Code === newCode);
    if (existingItemGroup != null) {
      this.confirmationDialogService.confirmTranslated(
        marker('ime.manufacturing.manufactured-item-groups.Template already exists'),
        marker('ime.manufacturing.manufactured-item-groups.Template with this code already exists'), {showYes: false, noLabel: 'OK'});
    } else {
      this.askCopyCodeNameModal.close();
      this.copyItemGroupClick.emit({code: newCode, name: newName});
    }
  }
}
